import { lazy } from 'react';

// Purchase & Plan Selection Flow - 10 components
// These pages are visited sequentially in the purchase funnel

export const DaySelection = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/DaySelection'
));

export const MealSelection = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/MealSelection'
));

export const PackageSelection = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/PackageSelection'
));

export const DeliveryOptions = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/DeliveryOptions'
));

export const AddressSelection = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/AddressSelection'
));

export const Summary = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/Summary'
));

export const PaymentStatus = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/Payment'
));

export const FindBestPlan = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/FindBestPlan'
));

export const PlanPreferences = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/PlanPreferences'
));

export const DietPreference = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/DietPreference'
));

export const AllPlans = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/AllPlans'
));

export const FeaturedPlans = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/FeaturedPlans'
));

export const Congrats = lazy(() => import(
  /* webpackChunkName: "purchase" */ '../../pages/Congrats'
));
